import React from 'react'
import Step1 from './Step1'
import Step2 from './Step2'
import Very from '../../../helpers/request_wrapper'
import StepNavigationHeader from '../../StepNavigationHeader'
import Loader from './Loader'
import { useDispatch, useSelector, Provider } from 'react-redux'
import store from '../../store';

export default function newPersona() {
  const handleSubmit = (e) => {
    this.audienceObject = {...this.audienceObject, ...e};

    console.log(this.audienceObject);

    if (this.state.currentStep === 3) {
      Very.post('/audiences', { audience: this.audienceObject }).then(res => {
        let persona_id = res.data[0].id;
        window.location.replace(`/personas/${persona_id}`)
      })
    }

    const maxStep = Math.max(this.state.currentStep + 1, this.state.maxStep);

    this.setState({ currentStep: this.state.currentStep + 1, maxStep: maxStep })
  };


  return (
    <Provider store={store}>
      <StepNavigationHeader
        cancelUrl="/"
        menu={['Industry', 'Location']}
      />

      <div className="col-12 py-110 sm-py4">
        <div className="center md-px3 mx-auto" style={{ maxWidth: '1110px' }}>
          <form onSubmit={handleSubmit}>
                <Step1/>
                <Step2/>
                <Loader/>
          </form>
        </div>
      </div>
    </Provider>
  );

}
